/**
 * Formats a number with commas as thousands separators.
 * Optionally rounds to a specified number of decimal places.
 *
 * Examples:
 * - formatNumberWithCommas(1234) -> "1,234"
 * - formatNumberWithCommas(1234.567, 2) -> "1,234.57"
 * - formatNumberWithCommas(1234567.89, 1) -> "1,234,567.9"
 * - formatNumberWithCommas(null) -> undefined
 *
 * @param number - The number to format (can be null/undefined)
 * @param decimalPlaces - Optional number of decimal places (default: preserves original)
 * @returns The number formatted with commas, or undefined for invalid inputs
 */
const formatNumberWithCommas = (
  number: number | null | undefined,
  decimalPlaces?: number,
): string | undefined => {
  // Validate input
  if (number === null || number === undefined || isNaN(number)) {
    return undefined;
  }

  // If decimalPlaces is specified, round to that precision
  const formattedNumber =
    decimalPlaces !== undefined
      ? number.toFixed(decimalPlaces)
      : number.toString();

  // Add commas as thousands separators
  return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default formatNumberWithCommas;
